import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: "ghost" | "primary" | "icon";
};

export function MobileButton({ children, variant = "ghost", className, ...props }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center justify-center rounded-xl text-sm font-medium transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--mail-accent)]",
        "disabled:pointer-events-none disabled:opacity-50",
        variant === "ghost" &&
          "h-10 min-w-10 px-2 text-[var(--mail-text)] hover:bg-[var(--mail-surface-hover)]",
        variant === "primary" &&
          "mail-btn-primary h-10 px-4",
        variant === "icon" &&
          "h-10 w-10 text-[var(--mail-text)] hover:bg-[var(--mail-surface-hover)]",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
